export default {
  state: {
    userName: "userName",
  },
};
